
// Notification
export function SuccessNotify(obj, msg) {
  obj.$notify({
    title: 'Success',
    message: msg,
    type: 'success',
    duration: 2000
  })
}

export function WarningNotify(obj, msg) {
  obj.$notify({
    title: 'Warning',
    message: msg,
    type: 'warning',
    duration: 2000
  })
}

export function ErrorNotify(obj, msg) {
  obj.$notify.error({
    title: 'Error',
    message: msg,
    duration: 2000
  })
}

// Message
export function SuccessMessage(obj, msg) {
  obj.$message({
    message: msg,
    type: 'success'
  })
}

export function WarningMessage(obj, msg) {
  obj.$message({
    message: msg,
    type: 'warning'
  })
}

export function ErrorMessage(obj, msg) {
  obj.$message.error(msg)
}

// String
export function isNotEmpty(str) {
  return str !== null && str !== undefined && str.length > 0
}



// WEBPACK FOOTER //
// ./src/utils/utils.js